import { RECURSOS } from '@/features/landing/conteudo';

/**
 * Grade de recursos. Um card por domínio entregue no MVP — a ordem é a do fluxo
 * de trabalho do veterinário (paciente → prontuário → exame → documento), não a
 * ordem de implementação.
 */
export function SecaoRecursos() {
  return (
    <section id="recursos" className="scroll-mt-20 border-b border-border bg-background py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wider text-accent">Recursos</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
           Tudo o que a rotina endocrinológica precisa, conectado.
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Do primeiro exame ao acompanhamento contínuo, cada informação permanece ligada ao paciente. Você encontra o histórico completo sem procurar em diferentes sistemas, arquivos ou conversas.
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {RECURSOS.map((recurso) => (
            <article
              key={recurso.titulo}
              className="group rounded-xl border border-border bg-card p-6 transition-colors hover:border-accent/50"
            >
              <div className="w-fit rounded-lg bg-gradient-nohra p-2.5 shadow-sm">
                <recurso.icone className="h-5 w-5 text-white" />
              </div>
              <h3 className="mt-4 font-semibold text-card-foreground">{recurso.titulo}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {recurso.descricao}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
